<div class="header">
    <img src="../../../assets/logo-site.png" alt="Logo" class="logo">
    <span class="header-text">Olá {{aluno}}</span>
    <button mat-button class="menu-button" (click)="isDesktop = !isDesktop">
        <mat-icon>menu</mat-icon>
    </button>
</div>
<div id="body" class="container">

    <div class="sidebar" *ngIf="isDesktop">
        <ul>
            <li *ngFor="let item of menuItems">
                <div (click)="linkSeletor(item.url,item.id)"
                    style="display: flex; justify-content: space-between; cursor: pointer;">
                    <img [src]="item.image" alt="{{ item.text }}">
                    <span>{{ item.text }}</span>
                </div>
            </li>
        </ul>
    </div>

    <div class="card-container">
        <div class="row">
            <div class="card col-md-4" *ngFor="let card of materias">
                <img [src]="'../../../assets/' + card.nomeMateria + '.png'" alt="{{ card.nomeMateria }}"
                    (click)="visualizaAula(matriculaId,card.id)" style="cursor: pointer;">
            </div>
        </div>
    </div>

</div>